"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.avatarColor = exports.AVATARS = void 0;
exports.AVATARS = {
    default: '#7b5bf5',
    blue: '#3d8bfd',
    teal: '#20c5b5',
    green: '#3fb950',
    yellow: '#e3b341',
    orange: '#f0883e',
    red: '#f85149',
    pink: '#db61a2',
};
var avatarColor = function (avatar) { var _a; return (_a = exports.AVATARS[avatar]) !== null && _a !== void 0 ? _a : exports.AVATARS.default; };
exports.avatarColor = avatarColor;
